
//import helpers from './../../helpers.js'
import moment from 'moment'

export default {

    namespaced:true,

    state: {

        fdb: {
            projects: [], // Will be bound as an array
            _projects: null // Will be bound as an object
        },

    },// state

    getters: {

        // basic crud
        getAll: (state,getters,rootState,rootGetters) => {
            return rootGetters.getAll('projects')
            if( !rootGetters.firebase_arrays.projects ) return []
            return rootGetters.firebase_arrays.projects
        },
        
        // basic crud
        //getOne: (state,getters,rootState,rootGetters) => (key) =>  { for( let item of getters.getAll ) if( item.key === key ) return item },
        // remove this and use generic getOne instead - right now this is just an unnecessary thin wrapper
        getOne: (state,getters,rootState,rootGetters) => (key) =>  { return rootGetters.getOne('project',key) },
        
        // remove this and use generic getOne instead
        getProject: (state,getters,rootState,rootGetters) => (project_key) => 
        {
            return rootGetters.getOne('project',project_key)
            if( !rootState.firebase.projects ) return
            var p = rootState.firebase.projects[project_key]
            return p
        },

        getFiltered: (state,getters,rootState,rootGetters) => (filters) => 
        {

            var output = []
            if( !filters ) filters = {}            
            var projects = getters.getAll

            for( let i = 0; i < projects.length; i++ ) {

                let project = projects[i]
                
                if( project.archived && !filters.include_archived ) continue

                if( filters.client_key != undefined && filters.client_key != 'undefined' ) {
                    if( filters.client_key != project.client_key ) continue
                }
                
                if( filters.project_key != undefined && filters.project_key != 'undefined' ) {
                    if( filters.project_key != project.project_key ) continue
                }

                if( filters.tag_in != undefined ) {                    
                    if( !project.tags ) continue
                    if( project.tags.toLowerCase().indexOf( filters.tag_in.toLowerCase() ) === -1 ) continue
                }

                // not yet tested
                if( filters.tag_not_in != undefined ) {
                    if( !project.tags || project.tags.toLowerCase().indexOf( filters.tag_not_in.toLowerCase() ) !== -1 ) continue
                }

                // currently no support for multiple tags, multiple whitelist AND/OR
                // currently no support for multiple tags, multiple blacklist AND/OR
                // perhaps not really needed?

                if( filters.project_keys != undefined ) {
                    if( filters.project_keys.indexOf(project.project_key) === -1 ) continue
                }

                if( filters.status != undefined && filters.status !== project.status ) continue
                if( filters.status_not != undefined && filters.status_not === project.status ) continue

                output.push(project)

            }

            return output

        },


        projects_without_budget( state,getters,rootState,rootGetters ){
            
            return rootGetters.getAll('projects').filter(function(project){
            //return rootGetters.firebase_arrays.projects.filter(function(project){
                if( !project.fixed_price ) return false
                return true
            })

            var output = [] 
            var list = rootState.firebase.projects
            for( var key in list ) { if(key == '.key') continue // why, vuexfire?
                var project = list[key]
                if( project.archived ) continue
                //console.log(project)
                if( project.fixed_price ) continue
                output.push(project)
            }
            return output
        },

        projects_without_timeline( state,getters,rootState,rootGetters ){
            var output = [] 
            //var list = rootState.firebase.projects
            var list = rootGetters.getAll('projects')
            for( var key in list ) { if(key == '.key') continue // why, vuexfire?
                var project = list[key]
                if( project.archived ) continue
                if( project.start_date && project.end_date ) continue
                output.push(project)
            }
            return output
        },

        active_projects_beyond_end_date( state,getters,rootState,rootGetters ){
            //console.log('running: active_projects_beyond_end_date')
            var output = [] 
            //var list = rootState.firebase.projects
            var list = rootGetters.getAll('projects')
            var now_date_timestamp = moment().unix()
            for( var key in list ) { if(key == '.key') continue // why, vuexfire?
                var project = list[key]
                if( project.archived ) continue
                if( project.status != 'active' ) continue
                if( !project.end_date ) continue
                var end_date_timestamp = moment(project.end_date,'YYYY-MM-DD').unix()
                if( now_date_timestamp < end_date_timestamp ) continue                
                output.push(project)
            }
            return output
        },

        most_profitable(state,getters,rootState,rootGetters)
        {
            var output = [] 
            //var list = rootState.firebase.projects
            var list = rootGetters.getAll('projects')
            for( var key in list ) { if(key == '.key') continue // why, vuexfire?
                var project = list[key]
                if( project.archived ) continue
                
                project.budget = getters.getBudget(project)

                if( !project.budget ) continue
                
                //project.hours_logged = rootGetters['timelogs/getFiltered']({project_key:key})
                project.hours_logged = rootGetters['timelogs/get_cached'].project[key]

                project.hour_earning = project.budget / project.hours_logged

                output.push(project)
            }
            return output
        },


        // 1. checks for fixed_price definition on project itself
        // 2. checks for accepted spec total
        // 3. finds hour_rate (with client hour_rate fallback) and looks at estimated hours
        // 4. should perhaps look at actually invoiceable hours?

        getBudget: (state,getters,rootState,rootGetters) => (project ) => 
        {
            
            if( typeof project === 'string' ) project = getters.getProject(project)
            if(!project) return
            var project_key = project.key || project['.key']
            
            if( project.fixed_price ) return parseFloat(project.fixed_price)

            var spec = rootGetters['specs/getByProjectKey'](project_key)
            if( spec ) return rootGetters['specs/getTotal'](spec)

            var hour_rate = getters.get_hour_rate(project)
            
            if( project.estimated_hrs && hour_rate ) return project.estimated_hrs * hour_rate 

            return 0
        
        },

        get_billable_hours: (state,getters,rootState,rootGetters) => (project) =>
        {
            var project_key = project.key || project['.key']

            var project_timelogs = rootGetters['timelogs/get_cached'].project[project_key]
            var billable_timelogs = project_timelogs.filter((t)=> t.billable === true )            
            var billable_timelogs_total_hours = rootGetters['timelogs/getTotalHours'](billable_timelogs)
            return billable_timelogs_total_hours
        },
            
        get_billable_hours_amount: (state,getters,rootState,rootGetters) => (project) =>
        {
            var hour_rate = getters.get_hour_rate(project)
            var billable_timelogs_total_hours = getters.get_billable_hours(project)
            return billable_timelogs_total_hours * hour_rate

        },

        get_payable_amount: (state,getters,rootState,rootGetters) => (project) =>
        {
            if( project.status === 'draft' ) return 0
            if( project.status === 'aborted' ) return 0
            if( project.payment_model == 'fixed_price' ) return getters.getBudget(project)
            
            if( project.payment_model == 'time_expense' ) return getters.get_billable_hours_amount(project)

            return 0
        },


        get_hour_rate: (state,getters,rootState,rootGetters) => (project) => 
        {
            
            if( project.hour_rate ) return project.hour_rate
            if( !project.client && !project.client_key ) return
            var client = project.client || rootGetters['clients/getClient'](project.client_key)            
            if( client && client.hour_rate ) return client.hour_rate
            
        },


        get_budgetted_hours: (state,getters,rootState,rootGetters) => (project) => 
        {
            if( !project ) return 0
            
            var project_key = project.key || project['.key']
            //if( !project_key ) return 0
        
            if( project.estimated_hrs ) return project.estimated_hrs

            var spec = rootGetters['specs/getByProjectKey'](project_key)
            if( spec ) return rootGetters['specs/getHours'](spec)

            var hour_rate = getters.get_hour_rate(project)
        
            if( hour_rate && project.fixed_price ) return parseFloat( project.fixed_price / hour_rate )

            return 0
        },


        get_budgetted_hours_spent_pct: (state,getters,rootState,rootGetters) => (project,timelogs) => 
        {
            var hrs = getters.get_budgetted_hours(project)
            var project_key = project.key || project['.key']
            
            timelogs = timelogs || rootGetters['timelogs/get_cached'].project[project_key]
            
            var spent_hrs = rootGetters['timelogs/getTotalHours'](timelogs)

            if( !hrs || !spent_hrs ) return 0

            var pct = ( spent_hrs / hrs * 100 )
            if( isNaN(pct) || !isFinite(pct) ) pct = 0        
            pct = parseInt(pct)        
            return pct

        },

        get_invoiced_dkk: (state,getters,rootState,rootGetters) => (project) => 
        {
            var economyposts = rootGetters['economyposts/getFiltered']({
                project_key: project.key,
                hypothetic: false,
                income_only: true,
                invoiced: true,
            })
            var totals = rootGetters['economyposts/getTotals'](economyposts)
            return totals.income_total
        },

        get_invoiced_and_paid_dkk: (state,getters,rootState,rootGetters) => (project) => 
        {
            var economyposts = rootGetters['economyposts/getFiltered']({
                project_key: project.key,
                hypothetic: false,
                income_only: true,
                invoiced: true,
                paid: true,
            })
            var totals = rootGetters['economyposts/getTotals'](economyposts)
            return totals.income_total
        },

        // look at economyposts - see if they are paid, see if they are invoiced, 
        is_fully_invoiced: (state,getters,rootState,rootGetters) => (project) => 
        {
            var amount_payable = getters.getBudget(project)
            var invoiced_dkk = getters.get_invoiced_dkk(project)
            return ( invoiced_dkk >= amount_payable )
        },

        is_fully_invoiced_and_paid: (state,getters,rootState,rootGetters) => (project) => 
        {
            var amount_payable = getters.getBudget(project)
            var invoiced_and_paid_dkk = getters.get_invoiced_and_paid_dkk(project)
            return ( invoiced_and_paid_dkk >= amount_payable )
        },


        
    },// getters

}


// WEBPACK FOOTER //
// ./src/store/modules/projects.js